// Backend (Mongo/Motor) returns naive UTC datetimes serialized without a 'Z'/offset,
// e.g. "2026-10-17T11:16:34.935". JS parses offset-less strings as BROWSER-LOCAL time,
// which breaks Nigerian-time display in non-UTC browsers. This axios response interceptor
// appends 'Z' to such strings so they are correctly treated as UTC; combined with the
// forceWAT display patch, every timestamp then renders in Africa/Lagos (WAT) for all users.
import axios from 'axios';

const ISO_NO_TZ = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;

const normalize = (val) => {
  if (typeof val === 'string') {
    return ISO_NO_TZ.test(val) ? val + 'Z' : val;
  }
  if (Array.isArray(val)) {
    for (let i = 0; i < val.length; i++) val[i] = normalize(val[i]);
    return val;
  }
  if (val && typeof val === 'object') {
    for (const k in val) {
      if (Object.prototype.hasOwnProperty.call(val, k)) val[k] = normalize(val[k]);
    }
    return val;
  }
  return val;
};

axios.interceptors.response.use(
  (response) => {
    if (response && response.data !== undefined) {
      response.data = normalize(response.data);
    }
    return response;
  },
  (error) => Promise.reject(error)
);
